
import HeroContainer from './components/HeroContainer.vue';
import AdvantagesSection from './components/AdvantagesSection.vue';
import TableOfContents from './components/TableOfContents.vue';
import ReasonsToUse from './components/ReasonsToUse.vue';
import EstimationStepsSection from './components/EstimationStepsSection.vue';
import EstimationCost from './components/EstimationCost.vue';
import DataProtectionSection from './components/DataProtectionSection.vue';
import { computed, defineComponent } from 'vue';
import thor from '@sl/thor';
import Cookies from 'js-cookie';

export default defineComponent({
  provide() {
    return {
      isMobile: computed(() => this.isMobile),
      valuationRangeOpened: computed(() => this.valuationRangeOpened),
    };
  },
  data() {
    return {
      valuationRangeOpened: this.isValuationRangeOpened(),
      isMobile: this.getIsMobile(),
    };
  },
  components: {
    HeroContainer,
    AdvantagesSection,
    TableOfContents,
    ReasonsToUse,
    EstimationStepsSection,
    EstimationCost,
    DataProtectionSection,
  },
  methods: {
    getIsMobile() {
      return window.innerWidth < 768;
    },
    isValuationRangeOpened() {
      return window.location.hash === '#valuate';
    },
    onResize() {
      this.isMobile = this.getIsMobile();
    },
    updateValuationRangeOpened() {
      this.valuationRangeOpened = this.isValuationRangeOpened();
    },
    initGTM() {
      const isContainerExist = Array.from(document.querySelectorAll('script'))
        .find(script => script.src.includes('GTM-5THNWXP'));

      if (!isContainerExist) {
        const script = document.createElement('script');
        script.innerHTML = `
        (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
        new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
        j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
        'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
        })(window,document,'script','dataLayer','GTM-5THNWXP');
      `;

        document.head.appendChild(script);
      }
    },
  },
  mounted() {
    this.initGTM();

    const userConsentInterval = setInterval(() => {
      const needUserInteraction = window.UC_UI?.isConsentRequired();

      if (needUserInteraction === false) {
        clearInterval(userConsentInterval);
        thor.onConsent();
      }
    }, 1000);

    const oauthCookie = (Cookies.get('oauth.access.token'));
    let userId;
    if (oauthCookie) {
      const userAuthObject = JSON.parse(atob(oauthCookie.split('.')[1]));

      if (userAuthObject && userAuthObject.sub) {
        userId = userAuthObject.sub;
      }
    }

    thor.pushEvent(
      'page_view',
      {
        'av_user': {
          'status': userId ? 'logged' : 'unlogged',
          'uid': userId,
        },
        'av_pagetitle': 'property_estimation',
        'av_category': 'estimate',
        'av_environment': (process.env.VUE_APP_MODE === 'live') ? 'prod' : process.env.VUE_APP_MODE,
        'av_url_path': '/anbieten/immobilienbewertung/lp/index.html',
        'av_language': 'de',
        'av_site': 'IWT',
        'av_platform': 'web',
      },
    );

    window.addEventListener('hashchange', this.updateValuationRangeOpened);

    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize);
    });
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.onResize);
    window.removeEventListener('hashchange', this.updateValuationRangeOpened);
  },
});
